import { render } from "./SingleSelect.vue?vue&type=template&id=75de589f"
import script from "./SingleSelect.vue?vue&type=script&lang=js"
export * from "./SingleSelect.vue?vue&type=script&lang=js"
script.render = render

export default script